/**
 * Nicky's Additions - 2025
 */
addEventListener("DOMContentLoaded", () => {
  if (gsap) {
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({
      force3D: false,
    })
  }

  bgImageBlock();
  breadcrumbStripColor();
  esgPages();
  klaviyoFormTriggers();
  mainNavigation();
  mpgCircleRotator();
  plpVideoHoverPlay();
  // scrollSmoother();
  swiper();
  removeShopPayAd();
  timedContent();
});


function removeShopPayAd() {
  let multiPackProduct = document.querySelector('.product--same-color, .product--different-color');
  let shopPayAd = document.querySelector('div[data-block-type="payment-terms"]');
  if (multiPackProduct) {
    shopPayAd.hidden = true;
  }
}

function bgImageBlock() {
  // Assigns 'position:relative' to the parent element 
  // Only when set to block relativity vs section (--relativity-block)
  // Remove hidden attribute that was placed to remove flash of misplaced content
  let blocks = document.querySelectorAll('.mci-block-bg-image--relativity-block');
  if (blocks) {
    blocks.forEach((block) => {
      let blockParent = block.parentElement;
      if (blockParent) {
        blockParent.classList.add('relative');
        block.classList.remove('hidden');
      }
    });
  };
}

function breadcrumbStripColor() {
  // Remove the "- Colour Name" from the breadcrumbs
  let productTemplate = document.body.classList.contains('template-product');
  let breadcrumbs = document.querySelector('.breadcrumb__list--pdp');

  if (productTemplate && breadcrumbs) {
    let breadcrumbCount = breadcrumbs.children.length - 1;
    let lastBreadcrumb = breadcrumbs.children[breadcrumbCount].firstElementChild;
    let newText = lastBreadcrumb.innerText.split(' - ')[0];
    lastBreadcrumb.innerText = newText;
  }

}

function esgPages() {
  if (window.matchMedia('screen and (min-width: 1000px)').matches) {

    let sectionBlockAnimate = document.querySelectorAll('.section-block-animate');
    let sectionBlockAnimateTrigger = document.querySelectorAll('#animate-trigger');
    if (sectionBlockAnimate) {
      gsap.from(sectionBlockAnimate, {
        autoAlpha: 0,
        duration: 1,
        x: '3500',
        stagger: 0.1,
        ease: 'none',
        scrollTrigger: {
          trigger: sectionBlockAnimateTrigger,
          start: 'top bottom+=25%',
          end: 'bottom center+=25%',
          scrub: 3
        }
      })
    }

    let bulletsFirst = document.querySelectorAll('ul.first-bullets li');
    let bulletsFirstTrigger = document.querySelectorAll('.first-bullets-animation');
    if (bulletsFirst && bulletsFirstTrigger) {
      gsap.from(bulletsFirst, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFirstTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsSecond = document.querySelectorAll('ul.second-bullets li');
    let bulletsSecondTrigger = document.querySelectorAll('.second-bullets-animation');
    if (bulletsSecond && bulletsSecondTrigger) {
      gsap.from(bulletsSecond, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsSecondTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsThird = document.querySelectorAll('ul.third-bullets li');
    let bulletsThirdTrigger = document.querySelectorAll('.third-bullets-animation');
    if (bulletsThird && bulletsThirdTrigger) {
      gsap.from(bulletsThird, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsThirdTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
    let bulletsFourth = document.querySelectorAll('ul.fourth-bullets li');
    let bulletsFourthTrigger = document.querySelectorAll('.fourth-bullets-animation');
    if (bulletsFourth && bulletsFourthTrigger) {
      gsap.from(bulletsFourth, {
        opacity: 0,
        x: 1500,
        ease: 'back.inOut',
        stagger: 1,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: bulletsFourthTrigger,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true
        }
      })
    }
  }


  let contentAnimated = document.querySelectorAll('.content-animated');
  let contentAnimatedTrigger = document.querySelectorAll('#animate-content');
  if (contentAnimated && contentAnimatedTrigger) {
    gsap.from(contentAnimated, {
      opacity: 0,
      y: -100,
      ease: 'none',
      duration: 3,
      autoAlpha: 0,
      scrollTrigger: {
        trigger: contentAnimatedTrigger,
        start: 'top center+=50%',
        scrub: true
      }
    })
  }

  let tencelIcons = document.querySelectorAll('#tencel-icons .image-wrapper');
  let tencelIconsTrigger = document.querySelectorAll('#tencel-icons');
  if (tencelIcons && tencelIconsTrigger) {
    if (window.matchMedia('screen and (min-width: 1000px)').matches) {
      gsap.from(tencelIcons, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: tencelIconsTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)

      if (window.matchMedia('screen and (max-width: 999px)').matches) {
        gsap.from(tencelIcons, {
          opacity: 0,
          x: -100,
          ease: 'back.inOut',
          stagger: 0.2,
          autoAlpha: 0,
          duration: 5,
          scrollTrigger: {
            trigger: tencelIconsTrigger,
            start: 'top center+=30%',
            end: 'bottom center+=30%',
            scrub: true
          }
        })
      }
    }
  }

  let esgChain = document.querySelectorAll('#esg-chain .image-wrapper');
  let esgChainTrigger = document.querySelectorAll('#esg-chain');
  if (esgChain && esgChainTrigger) {
    if (window.matchMedia('screen and (max-width: 1099px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -100,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }

    if (window.matchMedia('screen and (min-width: 1100px)').matches) {
      gsap.from(esgChain, {
        opacity: 0,
        x: -500,
        ease: 'back.inOut',
        stagger: 0.1,
        duration: 1,
        autoAlpha: 0,
        scrollTrigger: {
          trigger: esgChainTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      }, 0.2)
    }
  }

  if (window.matchMedia('screen and (min-width: 699px)').matches) {
    let tencelProcess = document.querySelectorAll('#tencel-process .image-wrapper');
    let tencelProcessTrigger = document.querySelectorAll('#tencel-process');
    if (tencelProcess && tencelProcessTrigger) {
      gsap.from(tencelProcess, {
        opacity: 0,
        y: -500,
        ease: 'back.inOut',
        stagger: 0.2,
        autoAlpha: 0,
        duration: 5,
        scrollTrigger: {
          trigger: tencelProcessTrigger,
          start: 'top center+=30%',
          end: 'bottom center+=30%',
          scrub: true
        }
      })
    }
  }
}

function klaviyoFormTriggers() {
  let maClub = document.querySelector('#klaviyo_form_trigger_ma_club');
  if (maClub) {
    maClub.addEventListener('click', function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'WeAGvZ']);
    });
  }
}

function mpgCircleRotator() {
  // Scripts required to make the MPG Circle Rotating Text block work

  const rotator = document.querySelector('.rotator');
  const playPause = document.querySelector('.mci-section-mpg-circle-rotating-text .mci-playpause-button');

  if (rotator) {
    let animation = gsap.timeline({ repeat: 20 });
    let targets = document.querySelectorAll('.rotator span');
    let numberOfTargets = targets.length;

    let duration = 0.6;
    let pause = 2;

    let stagger = duration + pause;
    let repeatDelay = stagger * (numberOfTargets - 1) + pause;

    function init() {
      gsap.set('.rotator', { autoAlpha: 1 });
      animation
        .from(targets, {
          y: 80,
          duration: duration,
          opacity: 0,
          ease: 'power2.out',
          stagger: {
            each: stagger,
            repeat: -1,
            repeatDelay: repeatDelay,
          },
        })
        .to(
          targets,
          {
            y: -80,
            duration: duration,
            opacity: 0,
            ease: 'power2.out',
            stagger: {
              each: stagger,
              repeat: -1,
              repeatDelay: repeatDelay,
            },
          },
          stagger
        );
    }
    // play/pause
    playPause.addEventListener('click', () => {
      animation.paused(!animation.paused());
      if (playPause.getAttribute('aria-label') == 'Pause') {
        playPause.setAttribute('aria-label', 'Play');
      } else {
        playPause.setAttribute('aria-label', 'Pause');
      }
    });

    init();
  }
}


function plpVideoHoverPlay() {
  let plpVideos = document.querySelectorAll('.product-card__media video');

  if (plpVideos.length != 0) {
    plpVideos.forEach((video) => {
      let videoCover = video.parentElement.querySelector('img');
      video.style.opacity = 1;

      video.parentElement.addEventListener('mouseover', (event) => {
        video.play();
        videoCover.style.opacity = 0;
      });

      video.parentElement.addEventListener('mouseout', (event) => {
        video.pause();
        videoCover.style.opacity = 1;
      });
    });
  }
}

function scrollSmoother() {
  gsap.registerPlugin(ScrollSmoother);

  if (ScrollSmoother) {
    // init
    ScrollSmoother.create({
      smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true, // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });

    // fix sticky stuff on PDP
    ScrollTrigger.create({
      trigger: "safe-sticky",
      start: "top",
      endTrigger: "scroll-carousel",
      end: "bottom bottom",
      pin: true,
      scrub: 1,
    });

  }

}

function swiper() {
  let checkForSwiper = document.querySelector('.swiper');
  if (checkForSwiper) {
    new Swiper('.swiper', {
      // Optional parameters
      a11y: true,
      direction: 'vertical',
      loop: false,
      parallax: true,
      speed: 800,
      oneWayMovement: true,

      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      scrollbar: {
        snapOnRelease: true,
      },

      accessibility: {
        enabled: true,
      },

      keyboard: {
        enabled: true,
      },

      virtual: {
        enabled: true,
        addSlidesAfter: 1,
      },

      mousewheel: {
        enabled: true,
        sensitivity: 0.005,
        // releaseOnEdges: true,
        thresholdDelta: 15,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
        snapOnRelease: true,
      },
    });
  }

}

function timedContent() {
  // Show hide content with the class "js-timed" based on the set show and hide time
  // Uses HTML 'hidden' attribute

  let timedContent = document.querySelectorAll('.js-timed');

  if (timedContent) {
    let now = Date.now();

    timedContent.forEach((item) => {
      let showTime = parseInt(item.dataset.timedStart);
      let hideTime = parseInt(item.dataset.timedEnd);

      if (now >= showTime && now <= hideTime) {
        item.hidden = false;
      }

    });
  }
}

function mainNavigation() {
  let dropdownButtons = document.querySelectorAll('.dropdown-toggle');
  let mobileMenuButton = document.getElementById('navToggle');

  /**
   * Main mobile navigation toggle
   * - Functioning, styling needed
   */
  if (mobileMenuButton) {
    mobileMenuButton.addEventListener("click", () => {
      event.preventDefault();
      let isExpanded = mobileMenuButton.getAttribute("aria-expanded");

      if (isExpanded == "false") {
        mobileMenuButton.setAttribute("aria-expanded", "true");
      } else {
        mobileMenuButton.setAttribute("aria-expanded", "false");
      }

      document.body.classList.toggle("nav-open");
    });
  }


  if (dropdownButtons) {
    /**
     * FUNCTION
     * Close all open dropdowns
     */
    function closeAllDropDowns() {
      dropdownButtons.forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
    }

    /**
     * FUNCTION
     * Toggle dropdown open/close
     */
    function toggleDropdown(event, button) {
      const isExpanded = button.getAttribute("aria-expanded") === "true";
      closeAllDropDowns();

      if (!isExpanded) {
        button.setAttribute("aria-expanded", "true");
      }
    }

    /**
     * FUNCTION
     * Close dropdown when clicking outside
     * - Does not work at the moment
     */
    function closeOnBlur(button, options = {}) {
      document.addEventListener("click", (event) => {
        if (
          event.target.parentElement.classList.contains("js-mci-nav-link") ||
          event.target.parentElement.classList.contains("nav-main__primary") ||
          event.target.parentElement.classList.contains("nav-main__primary__submenu")
        ) {
          // do nothing
        } else {
          closeAllDropDowns();
          document.body.classList.remove("nav-open");
        }
      });
    }

    /**
     * FUNCTION
     * Closes dropdowns when tabbing out of them
     */
    function handleFocus(button) {
      const subMenuListElement = button.nextElementSibling;

      button.addEventListener("focusout", (event) => {
        event.stopImmediatePropagation();
      });

      subMenuListElement.addEventListener("focusout", (event) => {
        const nextFocusElement = event.relatedTarget;

        const isSubMenuElement =
          nextFocusElement &&
          nextFocusElement.classList.contains("button") ||
          nextFocusElement.classList.contains("link") ||
          nextFocusElement.classList.contains("js-mci-nav-link");

        if (!isSubMenuElement) {
          closeAllDropDowns();
        }
      });
    }

    /**
     * EVENT
     * Adds event listeners to dropdown buttons (desktop)
     */

    dropdownButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        toggleDropdown(event, button);
      });

      closeOnBlur(button);
      handleFocus(button);
    });

    /**
     * EVENT
     * Closes menu on escape key
     */
    window.addEventListener("keydown", (event) => {
      if (event.key == "Escape") {
        document.body.classList.remove("nav-open");
        // mobileMenuButton.setAttribute("aria-expanded", "false");
        closeAllDropDowns();
      }
    });
  }
}